import userInformationTypes from './userInformationTypes'

export const initialState = {
  loading: false,
  getError: null,
  user: null,
  updateUserInformation: null,
  updateLoading: false,
  updateError: null,
  updateUserPhoto: null,
  udpateUserPhotoError: null,
  updateUserPhotoLoading: false,
  changeEmail: null,
  changeEmailError: null,
  changeEmailLoading: true,
  changePassword: null,
  changePasswordError: null,
  changePasswordLoading: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case userInformationTypes.GET_USER_INFORMATION: {
      return {
        ...state,
        loading: true,
        getError: null
      }
    }

    case userInformationTypes.GET_USER_INFORMATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        user: payload.data
      }
    }

    case userInformationTypes.GET_USER_INFORMATION_FAILURE: {
      return {
        ...state,
        loading: false,
        getError: payload
      }
    }

    case userInformationTypes.UPDATE_USER_INFORMATION: {
      return {
        ...state,
        updateLoading: true,
        updateError: null
      }
    }

    case userInformationTypes.UPDATE_USER_INFORMATION_SUCCESS: {
      const { data, user } = payload
      return {
        ...state,
        updateLoading: false,
        updateUserInformation: data,
        user: {
          ...state.user,
          ...user
        }
      }
    }

    case userInformationTypes.UPDATE_USER_INFORMATION_FAILURE: {
      return {
        ...state,
        updateLoading: false,
        updateError: payload
      }
    }

    case userInformationTypes.CHANGE_EMAIL_USER_INFORMATION: {
      return {
        ...state,
        changeEmailLoading: true
      }
    }

    case userInformationTypes.CHANGE_EMAIL_USER_INFORMATION_SUCCESS: {
      return {
        ...state,
        changeEmailLoading: false,
        changeEmail: payload,
        changeEmailError: false
      }
    }

    case userInformationTypes.CHANGE_EMAIL_USER_INFORMATION_FAILURE: {
      return {
        ...state,
        changeEmailLoading: false,
        changeEmail: payload,
        changeEmailError: true
      }
    }

    case userInformationTypes.UPDATE_PHOTO_USER_INFORMATION: {
      return {
        ...state,
        updateUserPhotoLoading: true
      }
    }

    case userInformationTypes.UPDATE_PHOTO_USER_INFORMATION_SUCCESS: {
      const user = state.user ? {
        ...state.user,
        avatar: payload.data.avatar
      } : {
        avatar: payload.data.avatar
      }
      return {
        ...state,
        updateUserPhotoLoading: false,
        updateUserPhoto: payload.data,
        user
      }
    }

    case userInformationTypes.UPDATE_PHOTO_USER_INFORMATION_FAILURE: {
      return {
        ...state,
        updateUserPhotoLoading: false,
        udpateUserPhotoError: payload
      }
    }

    case userInformationTypes.CHANGE_PASSWORD_USER_INFORMATION: {
      return {
        ...state,
        changePasswordLoading: true
      }
    }

    case userInformationTypes.CHANGE_PASSWORD_USER_INFORMATION_SUCCESS: {
      return {
        ...state,
        changePassword: payload,
        changePasswordError: false,
        changePasswordLoading: false
      }
    }

    case userInformationTypes.CHANGE_PASSWORD_USER_INFORMATION_FAILURE: {
      return {
        ...state,
        changePassword: payload,
        changePasswordError: true,
        changePasswordLoading: false
      }
    }

    case userInformationTypes.CLEAR_USER_INFORMATION: {
      return {
        ...state,
        user: null,
        updateUserInformation: null,
        updateUserPhoto: null
      }
    }

    default: {
      return state
    }
  }
}
